import React from 'react';
import { Link } from 'react-router-dom';
import { onChange, getCookie } from '../../utils';
import CONSTANT from '../../constant';
import Header from '../../component/common/Header';

import { getDateParts } from '../../utils';
import { getLeavesList, getLeaveSummary } from '../../actions/LeaveAction';
import Shimmer from '../../component/common/Shimmer';

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            list: undefined,
            date: new Date(),

            leaveType: { name: 'leaveType', value: 'all', error: '', isRequired: true },
            leaveSummary: undefined
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.allLeaves;
        this.loadList();
        this.loadLeaveSummary();

    }

    createdBy = (list: any) => {
        let CreatedBy: any = [];
        CreatedBy = list.map((item: any) => item.name);
        let filterCreateBy = CreatedBy.filter(function (item: any, pos: any) { return CreatedBy.indexOf(item) === pos; })

        return filterCreateBy.map((item: any) => {
            return <option value={item}> {item}</option>
        })

    }
    render() {
        const { list, leaveSummary, date } = this.state;
        const ud = getCookie(CONSTANT.cookie.userDetail);
        const myRequest = list !== undefined ? list.filter((i: any) => i.createdBy === ud.code) : undefined;
        const pendingWithMe = list !== undefined ? list.filter((i: any) => i.createdBy !== ud.code) : undefined;


        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-2 px-0">
                        <Header />
                    </div>
                    <div className="col-md-10">
                        <div className="row my-3">
                            <div className="col-md-12">
                                <h1 className="page-title">Leaves Balance</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row">
                                            {
                                                leaveSummary !== undefined && leaveSummary.filter((item: any) => item.code !== CONSTANT.static.leaveType.cml).map((item: any, index: any) => {
                                                    const balance = item.total - item.used - item.pending;
                                                    const isNumber = balance % 1 === 0;
                                                    return (
                                                        <div className="col" key={index}>
                                                            <strong style={{ fontSize: '2rem' }}>
                                                                {isNumber ? balance : balance.toFixed(2)}
                                                            </strong><br />
                                                            {item.name}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        {
                                            leaveSummary === undefined && <Shimmer />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="row mt-3">
                            <div className="col-md-8">
                                <h1 className="page-title">My Leave Request in {date.getFullYear()}</h1>
                            </div>
                            
                            <div className="col-md-2">
                                <Link to={CONSTANT.component.userLeaveEncashmentList.url} className="btn btn-sm submit-button btn-block">
                                    Leave Encashment
                                </Link>

                            </div>
                            <div className="col-md-2">
                                <Link to={CONSTANT.component.userApplyLeave.url} className="btn btn-sm submit-button btn-block">
                                    <i className="fa fa-plus-circle mr-2" />
                                    Request Leave
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                     
                                    <table className="table table-bordered table-hover">
                                     
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                {/* <th scope="col">Address</th> */}
                                                <th scope="col">Leave type</th>
                                                <th scope="col">From Date</th>
                                                <th scope="col">To Date</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Modified</th>
                                            </tr>
                                            {
                                                myRequest === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                myRequest !== undefined && myRequest.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                myRequest !== undefined && myRequest.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.userLeaveDetail.url.replace(':code', item.code);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    const fromDate = getDateParts(item.startDate);
                                                    const toDate = getDateParts(item.endDate);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            {/* <td>{item.addressTypeName}</td> */}
                                                            <td>{item.leaveTypeName}
                                                                {item.cancelled && <span className="badge badge-danger ml-1">Cancelled</span>}
                                                            </td>
                                                            <td>{`${fromDate.date} ${fromDate.monthName} ${fromDate.year}`}</td>
                                                            <td>{`${toDate.date} ${toDate.monthName} ${toDate.year}`}</td>
                                                            <td>{item.noOfDays}{item.leaveTypeId === CONSTANT.static.leaveType.cml && `(${item.noOfDays * 2} HPL)`}</td>
                                                            <td>
                                                                {
                                                                    item.cancellationRequestedOn === null && item.approved === null && <span>Pending</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn === null && item.approved !== null ? (item.approved ? <span className="text-success">Approved</span> : <span className="text-danger">Rejected</span>) : null
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn === null && <span className="text-info">Cancellation Requested</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn !== null && <span className="text-danger">Leave Cancelled</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn !== null && (item.cancellationStatus ? <span className="text-success">Cancellation Approved</span> : <span className="text-danger">Cancellation Rejected</span>)
                                                                }
                                                            </td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>


                        <div className="row mt-3">
                            <div className="col-md-12">
                                <h1 className="page-title">Request Pending With Me</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 mt-3">
                                <div className="list-container">
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th scope="col">S.No.</th>
                                                <th scope="col">Assigned To</th>
                                                <th scope="col">Requested by</th>
                                                {/* <th scope="col">Address</th> */}
                                                <th scope="col">Leave type</th>
                                                <th scope="col">From Date</th>
                                                <th scope="col">To Date</th>
                                                <th scope="col"># Days</th>
                                                <th scope="col">Status</th>
                                                <th scope="col">Modified</th>
                                            </tr>
                                            {
                                                pendingWithMe === undefined && <tr>
                                                    <td colSpan={9} className="text-center">Loading...</td>
                                                </tr>
                                            }
                                            {
                                                pendingWithMe !== undefined && pendingWithMe.length === 0 && <tr>
                                                    <td colSpan={9} className="text-center">No records found</td>
                                                </tr>
                                            }
                                            {
                                                pendingWithMe !== undefined && pendingWithMe.map((item: any, index: number) => {
                                                    const detailPageURL = CONSTANT.component.userLeaveDetail.url.replace(':code', item.code);
                                                    const dated = getDateParts(item.modifiedOn);
                                                    const fromDate = getDateParts(item.startDate);
                                                    const toDate = getDateParts(item.endDate);
                                                    return (
                                                        <tr key={index} className="c-pointer" onClick={() => this.openDetailPage(detailPageURL)}>
                                                            <td>{index + 1}</td>
                                                            <td>{item.assignedToName}</td>
                                                            <td>{item.createdByName}</td>
                                                            {/* <td>{item.addressTypeName}</td> */}
                                                            <td>{item.leaveTypeName}
                                                                {item.cancelled && <span className="badge badge-danger ml-1">Cancelled</span>}
                                                            </td>
                                                            <td>{`${fromDate.date} ${fromDate.monthName} ${fromDate.year}`}</td>
                                                            <td>{`${toDate.date} ${toDate.monthName} ${toDate.year}`}</td>
                                                            <td>{item.noOfDays}</td>
                                                            <td>
                                                                {
                                                                    item.cancellationRequestedOn === null && item.approved === null && <span>Pending</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn === null && item.approved !== null ? (item.approved ? <span className="text-success">Approved</span> : <span className="text-danger">Rejected</span>) : null
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn === null && <span className="text-info">Cancellation Requested</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn === null && item.cancellationManagedOn !== null && <span className="text-danger">Leave Cancelled</span>
                                                                }
                                                                {
                                                                    item.cancellationRequestedOn !== null && item.cancellationManagedOn !== null && (item.cancellationStatus ? <span className="text-success">Cancellation Approved</span> : <span className="text-danger">Cancellation Rejected</span>)
                                                                }
                                                            </td>
                                                            <td>{`${dated.date} ${dated.monthName} ${dated.year}`}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>




                        <div className="row">
                            <div className="col-md-2">
                                <button type="button" onClick={this.previousYear} className="btn btn-link btn-sm next-control btn-block">
                                    <i className="fa fa-angle-double-left mr-1 pe-none" aria-hidden="true"></i>
                                    Year {date.getFullYear() - 1}
                                </button>
                            </div>
                            <div className="col-md-8"></div>
                            <div className="col-md-2">
                                <button type="button" onClick={this.nextYear} className="btn btn-link btn-sm float-right next-control btn-block">
                                    Year {date.getFullYear() + 1}
                                    <i className="fa fa-angle-double-right ml-1 pe-none" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    onChange = (e: any) => {
        onChange(this, e.target.name, e.target.value);
    }

    typeaheadOnChange = (name: string, e: any) => {
        let value = e;
        if (e.length > 0 && e[0].customOption) {
            value = [{ name: e[0].name }];
        }
        onChange(this, name, value);
    }

    previousYear = () => {
        this.setState({ date: new Date(this.state.date.setFullYear(this.state.date.getFullYear() - 1)) }, () => {
            this.loadList();
            this.loadLeaveSummary();
        });

    }
    nextYear = () => {
        this.setState({ date: new Date(this.state.date.setFullYear(this.state.date.getFullYear() + 1)) }, () => {
            this.loadList();
            this.loadLeaveSummary()
        });
    }

    loadLeaveSummary = () => {
        const { date } = this.state;
        getLeaveSummary(date.getFullYear()).then((res: any) => {
            if (res) {
                this.setState({
                    leaveSummary: res.result.leaveTypeList
                })
            }
        });
    }

    loadList = () => {
        const { date } = this.state;
        getLeavesList(date.getFullYear()).then((res: any) => {
            if (res) {
                this.setState({ list: res.result });
            }
        });
    }

    openDetailPage = (url: string) => {
        this.props.history.push(url);
    }
}

export default ComponentName;